/** CSGCylinder3D's solid, exposed to the boolean evaluator. */
import { primitiveSolid } from '../../../../r3f/csg/csgRegistration';
import { buildCsgCylinderGeometry } from './cylinderGeometry';
export const csgCylinder3DGeometry = (properties) => {
    const p = properties;
    return primitiveSolid(buildCsgCylinderGeometry({
        radius: p.radius,
        height: p.height,
        sides: p.sides,
        cone: p.cone,
        smoothFaces: p.smoothFaces,
        flipFaces: p.flipFaces,
    }), p);
};
export function csgCylinder3DGeometryKey(properties) {
    const p = properties;
    return `cyl:${p.radius},${p.height},${p.sides},${p.cone},${p.smoothFaces},${p.flipFaces}`;
}
//# sourceMappingURL=csgGeometry.js.map